import React from 'react'
import {AppBar, Box, Toolbar, Button} from '@material-ui/core'
import {makeStyles} from '@material-ui/core/styles'
import HelpButton from './Nav/HelpButton'
import UserButton from './Nav/UserButton'
import MobileMenu from './Nav/MobileMenu'
import SubMenu from './Nav/SubMenu'
import ErrorBoundary from './ErrorBoundary'
import {Link as RouterLink, useLocation} from 'react-router-dom'
import {withRouter} from 'react-router'

// Images
import logo from '../images/lettermark-diving-eagle-white.svg'

// using hook API
const useStyles = makeStyles(theme => ({
    appBar: {
        color: 'primary',
        height: '4rem',
        position: 'static',
        boxShadow: 'none',
    },
    toolBar: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: '#098447',
        position: 'relative',
        zIndex: 5,
        minHeight: '54px',
    },
    logoBox: {
        display: 'flex',
        alignItems: 'center',
    },
    logoImg: {
        height: '60px',
        margin: '15px 0 0 0',
    },
    logoText: {
        fontSize: '1rem',
        textAlign: 'left',
        letterSpacing: 0,
        color: theme.palette.common.white,
        opacity: 1,
        fontWeight: '600',
        lineHeight: '1.2rem',
    },
    naviconBox: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '90px',
        position: 'fixed',
        right: '25px',
        zIndex: 10,
        [theme.breakpoints.down('sm')]: {
            width: '130px',
            right: '0px',
        },
    },
    menuContainer: {
        margin: '0 0 0 50px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    buttonBox: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    menuButton: {
        color: theme.palette.common.white,
        margin: '0 0 0 0',
        padding: '0 15px 0 15px',
        boxShadow: 'none',
        height: '1rem',
        textTransform: 'uppercase',
        '&:hover': {
            boxShadow: 'none',
            opacity: 0.8,
        },
    },
    buttonNotch: {
        width: '10px',
        height: '10px',
        position: 'absolute',
        top: '44px',
        borderLeft: '10px solid transparent',
        borderRight: '10px solid transparent',
        borderBottom: '10px solid #025420',
    },
    mobileMenu: {
        display: 'none',
        [theme.breakpoints.down('sm')]: {
            display: 'flex',
        },
    },
}))

const Nav = props => {
    const classes = useStyles()
    const {userrole, activedeptuserrole} = props

    let location = useLocation()
    const {pathname} = location

    return (
        <>
            <AppBar className={classes.appBar}>
                <Toolbar className={classes.toolBar}>
                    <Box className={classes.logoBox}>
                        <img
                            src={logo}
                            alt="logo"
                            className={classes.logoImg}
                        />
                    </Box>
                    <Box className={classes.menuContainer}>
                        <div className={classes.buttonBox}>
                            <Button
                                className={classes.menuButton}
                                component={RouterLink}
                                to={'/swiping'}
                            >
                                Swiping
                            </Button>
                            {['/swiping', '/'].includes(pathname) ? (
                                <div className={classes.buttonNotch} />
                            ) : null}
                        </div>
                        {[
                            'Super Admin',
                            'Department Admin',
                            'Department Creator',
                        ].includes(userrole) ? (
                            <div className={classes.buttonBox}>
                                <Button
                                    className={classes.menuButton}
                                    component={RouterLink}
                                    to={'/eventsetup'}
                                >
                                    Event Setup
                                </Button>
                                {['/eventsetup', '/swipeteams'].includes(
                                    pathname
                                ) ? (
                                    <div className={classes.buttonNotch} />
                                ) : null}
                            </div>
                        ) : null}
                        {['Super Admin', 'Department Admin'].includes(
                            userrole
                        ) ? (
                            <div className={classes.buttonBox}>
                                <Button
                                    className={classes.menuButton}
                                    component={RouterLink}
                                    to={'/manageroles'}
                                >
                                    Manage Roles
                                </Button>
                                {[
                                    '/manageroles',
                                    '/departmentroles',
                                    '/superadminroles',
                                ].includes(pathname) ? (
                                    <div className={classes.buttonNotch} />
                                ) : null}
                            </div>
                        ) : null}
                    </Box>
                    <Box className={classes.naviconBox}>
                        <ErrorBoundary>
                            <HelpButton userrole={userrole} />
                        </ErrorBoundary>
                        <ErrorBoundary>
                            <UserButton
                                userrole={userrole}
                                activedeptuserrole={activedeptuserrole}
                            />
                        </ErrorBoundary>
                        <ErrorBoundary>
                            {userrole !== 'Swiper' ? (
                                <div className={classes.mobileMenu}>
                                    <MobileMenu userrole={userrole} />
                                </div>
                            ) : null}
                        </ErrorBoundary>
                    </Box>
                </Toolbar>
                <SubMenu branch={pathname} userrole={userrole} />
            </AppBar>
        </>
    )
}

export default withRouter(Nav)
